export default "__VITE_ASSET__87d01106__"